module.exports = __webpack_public_path__ + "static/media/necklaces.84438444.jpg";